export default {
  name: 'Televisa Univision Acervo Literario',
  desc: 'Televisa - acervo',
  prefix: 'boss',
  footerText: 'Televisa acervo | Todos los derechos reservados 2018',
  logoText: 'Acervo',
  needLogin: true
};
